// extracted by mini-css-extract-plugin
export default {"loadingElement":"element_loadingElement__RZSUN","spin":"element_spin__2dzwy"};